import { Box } from '@mantine/core'
import React from 'react'

const ProgressBarPart = ({widthPercentage, color}:{widthPercentage: number, color: string}) => {
  return (
    <Box
      w={`${widthPercentage || 0}%`}
      bg={color}
    ></Box>
  )
}

export default ProgressBarPart